import {
    getInvalidItemFields,
    ITEM_BASE_FIELDS,
    ITEM_DIMENSION_FIELDS,
    ITEM_MARKETPLACE_FIELDS,
} from '@onward-delivery/core';

// Shared by the modal-level aggregate (isValid / hasErrorTab) and by each item row, so a row can
// derive its own errors from its own item instead of taking a per-keystroke prop from the parent.
export const getItemErrors = (item, { oms, freightType, sourceForm, assemblyRequired }) => {
    const invalidFields = new Set(
        getInvalidItemFields(item, {
            oms,
            freight_type: freightType,
            assembly_required: assemblyRequired,
        })
    );
    const isEmpty = (attr) => !item[attr] || item[attr].length === 0;
    const setFieldError = (field, hasError) => {
        if (hasError) invalidFields.add(field);
        else invalidFields.delete(field);
    };

    invalidFields.delete('quantity');

    ITEM_BASE_FIELDS.filter((field) => field !== 'quantity').forEach((field) => {
        setFieldError(field, isEmpty(field));
    });

    ITEM_DIMENSION_FIELDS.forEach((field) => {
        setFieldError(field, isEmpty(field) && isEmpty('cubes_per_unit'));
    });
    setFieldError(
        'cubes_per_unit',
        isEmpty('cubes_per_unit') && ITEM_DIMENSION_FIELDS.every((field) => isEmpty(field))
    );

    const requiresMarketplaceFields = !oms && freightType === 'household';
    ITEM_MARKETPLACE_FIELDS.forEach((field) => setFieldError(field, requiresMarketplaceFields && isEmpty(field)));

    const requiresAssembly = requiresMarketplaceFields || assemblyRequired;
    const hasAssemblyError = isEmpty('assembly_type') || (assemblyRequired && item.assembly_type === 'no_assembly');
    setFieldError('assembly_type', requiresAssembly && hasAssemblyError);

    const requiresPieceCount = !oms && sourceForm === 'CUSTOMER';
    setFieldError('item_piece_count', requiresPieceCount && isEmpty('item_piece_count'));

    return Object.fromEntries([...invalidFields].map((field) => [field, true]));
};
